import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { get as getProjection, transformExtent } from 'ol/proj';
import { Point } from 'ol/geom';
import { Coordinate } from 'ol/coordinate';
import * as proj from 'ol/proj';

/* Define the mgi lambert projection including busa wolf parameter to be ablt to reproject to google */
proj4.defs(
    'EPSG:31287',
    '+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs',
);
register(proj4); /* register the projection in ol core */
/* Set the extents for each projection */
const austria_extent_31287 = [107778.5323, 286080.6331, 694883.9348, 575953.615];
getProjection('EPSG:31287')?.setExtent(austria_extent_31287);
/**
 * Get the extent of autria in google projection (needed to set the map limits and the initial map
 * display in the case no preselection and / or selection is provided)
 **/

export const austria_extent = transformExtent(austria_extent_31287, 'EPSG:31287', 'EPSG:3857');

export const EPSG31287 = getProjection('EPSG:31287');
export const EPSG3857 = getProjection('EPSG:3857');
export const EPSG4326 = getProjection('EPSG:4326');

/**
 * Reproject a give point into the basemap at projection.
 * @param point The point that will be reprojected from EPSG:31287 to EPSG:3857 (Google Projection = Projection of basemap at.)
 * @returns The reprojected Point.
 */
export const reprojectTo3857 = (point: Point) => {
    if (EPSG31287 && EPSG3857) {
        return point.transform(EPSG31287, EPSG3857).clone();
    } else { return point; }

};

/**
 * Reproject a give point into the basemap at projection.
 * @param point The point that will be reprojected from EPSG:31287 to EPSG:3857 (Google Projection = Projection of basemap at.)
 * @returns The reprojected Point.
 */
 export const reprojectCoordTo3857 = (coord: Coordinate) => {
    if (EPSG31287 && EPSG3857) {
        return proj.transform(coord, EPSG31287, EPSG3857);
    } else { return coord; }

};
